import { PropTypes } from "@l2r-front/l2r-proptypes"

import { BurgerMenu } from "../../containers/BurgerMenu"

import * as Styled from "./AuthenticatedMobileLayout.styled"

export function AuthenticatedMobileLayout(props) {
    const { children } = props

    return <>
        <Styled.MenuWrapper>
            <BurgerMenu />
        </Styled.MenuWrapper>
        {children}
    </>
}

AuthenticatedMobileLayout.propTypes = {
    children: PropTypes.node.isRequired,
}
